<template>
    <div>
        <van-steps :active="active">
            <van-step>申报信息</van-step>
            <van-step v-show="isUpload">附件上传</van-step>
            <van-step v-show="emsNeeded === 'Y'">办理方式</van-step>
            <van-step>提交确认</van-step>
        </van-steps>
    </div>
</template>

<script>
  /**
   * Description: 申报事项步骤条
   * Author: wangyan
   * Date: 2019-04-29
   * Time: 09:53
   */

  import { Step, Steps } from 'vant'

  export default {
    name: "Steps",
    components: {
      [Step.name]: Step,
      [Steps.name]: Steps
    },
    props: {
      active: { // 步骤条下标
        type: Number,
        default: 0
      },
      isUpload: { // 是否存在图片
        type: Boolean,
        default: false
      },
      emsNeeded: {
        type: String,
        default: 'Y'
      }
    },
    data() {
      return {}
    }
  }
</script>

<style scoped>

</style>
